<template>
    <div class="courier_status_item" :style="styleError" @click.prevent="clickLogItem">
        <div class="courier_status_item_sign" :class="imgClass">
            <img :src="'/icons/'+this.status_courier+'.svg'">
        </div>
        <div class="courier_status_item_info">
            <div class="courier_status_item_info_block">
                <span class="courier_status_item_info_block_time">{{ timeCourier }}</span>
                <span class="courier_status_item_info_block_state">{{ stateCourier }}</span>
            </div>
            <div v-if="isInfo" class="courier_status_item_info_text">
                {{ infoCourier }}
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "courier_status_item",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {}
    },
    methods: {
        clickLogItem() {
            // if (this.isError) {
            //     let logInfo = {};
            //     if (this.item.action_data) {
            //         logInfo.action_data = this.item.action_data;
            //     }
            //     if (this.item.payload) {
            //         logInfo.payload = this.item.payload;
            //     }
            //     EventBus.$emit('show_modal_left', logInfo);
            // }
        },
    },
    computed: {
        status_courier() {
            if (this.isError) {
                return 'status_process';
            }
            return 'status_ready';
        },
        timeCourier() {
            if (this.item.added) {
                let dateOrder = new Date(this.item.added);
                let hours = dateOrder.getHours();
                let minutes = dateOrder.getMinutes();
                let seconds = dateOrder.getSeconds();
                if (hours < 10) {
                    hours = '0' + hours;
                }
                if (minutes < 10) {
                    minutes = '0' + minutes;
                }
                if (seconds < 10) {
                    seconds = '0' + seconds;
                }
                return hours + ':' + minutes + ':' + seconds;
            }
            return '';
        },
        stateCourier() {
            if (this.item.action_type) {
                return this.item.action_type;
            }
            return '';
        },
        infoCourier() {
            if(this.item.info){
                return this.item.info;
            }
            return '';
        },
        isInfo() {
            return this.item.info && this.item.info !== '';
        },
        isError() {
            return this.item.status && this.item.status === "operation_fail";
        },
        styleError() {
            if (this.isError) {
                return 'cursor: pointer;'
            }
            return '';
        },
        logFullString() {
            return JSON.stringify(this.item, null, 2).trim();
        },
        imgClass() {
            if (this.isInfo) {
                return {'info': true};
            }
            return '';
        }
    },
}
</script>
